// extracted by mini-css-extract-plugin
export default {"label":"text-field_label__9+sAe","input":"text-field_input__i-Ueu","icon":"text-field_icon__XndvZ"};